import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';

import './styles.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Loading from '../../components/Loading/Loading';

import PeriodContext from '../../Contexts/PeriodContext';
import apiTuig from '../../services/apiTuig';

import { UltimaAtualizacao, Produto } from '../../Types/Types';
import LoginContext from '../../Contexts/LoginContext';

import { useHistory } from 'react-router-dom';

const Produtos = () => {

        const Period = useContext(PeriodContext);
        const Login = useContext(LoginContext);
        
        //Funcionamento do filtro de busca e enter no input
        const [txtProduto, settxtProduto] = useState('');
        const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            settxtProduto(event.target.value);
        };
        const handlePressEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
                if (event.key === 'Enter') {
                    HandleClickButtonBuscarProduto();
                }
        };
        
        const history = useHistory();

        const [produtos, setProdutos] = useState<Produto[]>([{
                    idProduto: '',
                    descricao: '',
                    estoque: '',
                    valorVenda: 0
                }]);

        const [carregandoProdutos,setCarregandoProdutos] = useState(true);
        const [ultimaAtualizacao, setUltimaAtualizacao] = useState<UltimaAtualizacao>({
            ultAtualizacao: '',
            regPendentes: '',
            error: ''
        });

        useEffect(() => {
            LoadHome();       
        },[]); 

        async function CarregarUltAtualizacao() {
            try {
                if (Login.user != null) {
                    await apiTuig.get(`ultimaAtualizacao?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}`).then(response => {
                        setUltimaAtualizacao(response.data);
                        //Se senha ou autorizacao mudar no servidor, desloga usuario
                        if (response.data.error !== '') {
                            alert(response.data.error);
                            return (
                                <div>
                                    {GoToLogin()};
                                </div>
                            )
                        }
                        })
                    }
            } catch (err) {
                alert(`Erro ao carregar hora da última atualização, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        async function CarregarProdutos() {
            try {
                if (Login.user != null) {
                    setCarregandoProdutos(true);
                    await apiTuig.get<Produto[]>(`produtos?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}`).then(response => {
                        const produto = response.data;
                        setProdutos(produto);
                        setCarregandoProdutos(false);   
                    })
                }
            } catch (err) {
                setCarregandoProdutos(false);
                alert(`Erro ao carregar produtos, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
            }
        }

        function HandleClickButtonBuscarProduto() {
                    try {
                        if (Login.user != null) {
                            setCarregandoProdutos(true);
                             apiTuig.get<Produto[]>(`produtos?acessKey=${Login.client}&user=${Login.user}&pass=${Login.pass}&busca=${txtProduto}`).then(response => {
                                const produto = response.data;
                                setProdutos(produto);
                                setCarregandoProdutos(false);   
                            })
                        }
                    } catch (err) {
                        setCarregandoProdutos(false);
                        alert(`Erro ao carregar produtos, verifique a conexão com a internet e tente novamente. -> ${String(err)}`);
                    }
                return;
            }

        useEffect(() => {
            CarregarUltAtualizacao();
            {/* Comenttado e setado para falso para não carregar todos os produtos na primeira abertura nem mostrar o loading infinito */}
            //CarregarProdutos();
            setCarregandoProdutos(false);
        },[]);

        function GoToLogin() {
            history.push('/');
        }
    
        function LoadHome() {
            // if (sessionStorage.getItem('@tuigcloud/dayFrom') != null) {
            //     const momentObj = moment(sessionStorage.getItem('@tuigcloud/dayFrom'), 'DD/MM/YYYY');
            //     Period.dayFrom = momentObj.toDate();
            // }
            Login.isAutenticated = sessionStorage.getItem('@tuigcloud/isAutenticated');
            Login.user = sessionStorage.getItem('@tuigcloud/user');
            Login.pass = sessionStorage.getItem('@tuigcloud/pass');
            Login.client = localStorage.getItem('@tuigcloud/client');
            Login.clientName = sessionStorage.getItem('@tuigcloud/clientName');
            
            if (Login.isAutenticated === 'true') {
                return (
                        <div id="home">
                    <div className="content">
                        <Header />
                        <br/>
                        <br/>
                        <p>Atualizado em {ultimaAtualizacao.ultAtualizacao}</p>
                        <p>{ultimaAtualizacao.regPendentes} registros a sincronizar</p>
                        <br/>
                        <h3>{Login.clientName}</h3>
                        <h1>Produtos</h1>
                        <br/>
                        <input id="inputBuscaProduto" type="text" value={txtProduto} onChange={handleInputChange} placeholder='Nome do produto' onKeyPress={handlePressEnter}/>
                        <button id="botaoBuscarProduto" type="button" onClick={HandleClickButtonBuscarProduto}>buscar</button>
                        <br/>
                        <br/>
                        {carregandoProdutos ? <Loading /> : <div id="container"> {/* If ternario no início para caso o array seja vazio não mostrar nem o spinner de loading nem ps textos complementares tipo o P adicional do código do produto */}
                                                               {produtos.map(produto => (produto.idProduto ?  
                                                               <p key={produto.idProduto}> P{produto.idProduto} - {produto.descricao}
                                                               <br/>
                                                               Estoque: {produto.estoque}
                                                               <br/>
                                                               Valor Venda: {produto.valorVenda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} 
                                                               <hr/>
                                                               </p>
                                                               
                                                               : '' ))}  
                                                               <br/>
                                                               </div>}
                        <Footer />
                        
                    </div>
                </div>
                )
            }
            else {
                return (
                    <div>
                        {GoToLogin()};
                    </div>
                )
            }
        }
    return (
        <div>{LoadHome()}</div>
    );
};

export default Produtos;
